import styled, { css } from 'styled-components'

import { button } from 'components/Editor/styled/Button'

export const CourseHeaderLogoStyled = styled.button<{ $active: boolean }>`
  ${button}
  max-width: 100%;
  padding: 6px;
  border: none;
  border-radius: var(--border-radius-inner);

  ${({ $active }) =>
    $active &&
    css`
      cursor: pointer;
    `}
`

export const CourseHeaderLogoImage = styled.img`
  height: 32px;
  max-width: 100%;
  max-height: 32px;
  object-fit: contain;
`
